import * as JsonSchema from '../../utils/json-schema'

export type T = ReadingFormResponsesApiResponse

type ReadingFormResponsesApiResponse = ReadingFormResponse[]

type ReadingFormResponse = {
  formId: string
  formVersion: string
  mode: 'free' | 'planned'
  observedOver: ObservedOver
  submittedAt: string
  submittedBy: string
  lastPatchedAt: string
  lastPatchedBy: string
  deviceId: string
  values: Record<string, number>
  comment: string
}
type ObservedOver = [string, string]

const OBSERVED_OVER_SCHEMA:JsonSchema.T<ObservedOver> = {
  type           : 'array',
  minItems       : 2,
  additionalItems: false,
  items          : [ { type: 'string' }, { type: 'string' } ],
}

const READING_FORM_RESPONSE_SCHEMA:JsonSchema.T<ReadingFormResponse> = {
  type    : 'object',
  required: [
    'formId',
    'formVersion',
    'mode',
    'observedOver',
    'submittedAt',
    'submittedBy',
    'lastPatchedAt',
    'lastPatchedBy',
    'deviceId',
    'values',
    'comment',
  ],
  properties: {
    formId       : { type: 'string' },
    formVersion  : { type: 'string' },
    mode         : { type: 'string', 'enum': [ 'free', 'planned' ] },
    observedOver : OBSERVED_OVER_SCHEMA,
    submittedAt  : { type: 'string' },
    submittedBy  : { type: 'string' },
    lastPatchedAt: { type: 'string' },
    lastPatchedBy: { type: 'string' },
    deviceId     : { type: 'string' },
    values       : { type: 'object', additionalProperties: { type: 'number' }, required: [] },
    comment      : { type: 'string' },
  }
}

const READING_FORM_RESPONSES_API_RESPONSE_SCHEMA: JsonSchema.T<ReadingFormResponsesApiResponse> = {
  type : 'array',
  items: READING_FORM_RESPONSE_SCHEMA
}

export const parse = JsonSchema.parserForCollection(READING_FORM_RESPONSES_API_RESPONSE_SCHEMA, 'form values api responses')
